import React, { Component } from 'react'
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { notifications } from 'data/actions';
import Price from 'components/Formaters/Price';
import Mail from 'material-ui/svg-icons/communication/email';
import Badge from 'material-ui/Badge';

import PersonIcon from "material-ui/svg-icons/social/person";

class MessageInfo extends Component {


  componentDidMount () {
    this.props.actions.fetchNotifications(this.props.accountid);
  }
  
  render () {
    return this.props.count ? 
      <Badge className="message-info" badgeContent={this.props.count}>
        <Mail/>
      </Badge>
    :
      <Mail/>    
  }
}

function mapStateToProps(state, ownProps) {
  
  var count = _.reduce(state.notifications.list.data, function(sum, n) {
    return sum + (n.read ? 0 : 1);
  }, 0);

  return {
    count: count
  };
}
const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...notifications }, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatch)(MessageInfo)

  



// WEBPACK FOOTER //
// ./src/components/Balance/MessageInfo.jsx